'use client';

import {
  useAccountTexts,
  useDrawerTexts,
} from '@eliadmin/core/src/components/nt/shared/site-texts';
import type { CheckoutTexts } from '@eliadmin/core/src/utils/nt/checkout';
import { pluralText, splitOptions } from '@eliadmin/core/src/utils/nt/text';

/**
 * Admin texts of the orders: „Konto - …“ from the profile layout and the shared cart words
 * („Košík - produkty / kusy / medzisúčet …“, „Objednávka - stavy“), both provided by the profile
 * layout (`useDrawerTexts` reads the provider first, so it is never `null` here).
 */
export function useOrderTexts() {
  const account = useAccountTexts();
  const checkout = useDrawerTexts();
  return { account, checkout };
}

/** „3 produkty“ and „4 ks“ for the `{produkty}` / `{kusy}` placeholders, `null` without the texts. */
export function countLabels(
  checkout: CheckoutTexts | null,
  counts: { products: number; pieces: number },
) {
  if (!checkout) return null;
  return {
    produkty: pluralText(checkout.products, counts.products),
    kusy: pluralText(checkout.pieces, counts.pieces),
  };
}

/** The four steps of „Stav objednávky“ („Prijatá | Pripravujeme | Odoslaná | Doručená“). */
export function statusSteps(checkout: CheckoutTexts | null) {
  return checkout ? splitOptions(checkout.statuses) : [];
}
